import { FaRegQuestionCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import "../../../styles/ModelStatistics.css";

function StatisticCard({ title, hint, children, customTitle }) {
  return (
    <motion.div
      className="statisticsCard"
      role="listitem"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ y: -2 }}
    >
      {customTitle ? (
        <div className="mb-3">{customTitle}</div>
      ) : title ? (
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-test text-base sm:text-lg font-semibold flex items-center">
            {title}
            {hint && (
              <span className="relative group inline-block ml-2 custom-font">
                <FaRegQuestionCircle className="text-test/70 hover:text-test transition-colors" />
                <span className="hint">{hint}</span>
              </span>
            )}
          </h3>
        </div>
      ) : null}

      <div className="statistic-content">{children}</div>
    </motion.div>
  );
}

export default StatisticCard;
